'use client';

import { c as _c } from "react/compiler-runtime";
import React, { ReactNode } from 'react';
import { Provider } from 'react-redux';
import { instantiateStore, reduxStore, Store as StoreType } from '@/app/_components/store/store';
export const Store = props => {
  const $ = _c(5);
  let t0;
  if ($[0] !== props.initialData) {
    t0 = instantiateStore(props.initialData);
    $[0] = props.initialData;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const store = t0;
  let t1;
  if ($[2] !== props.children || $[3] !== store) {
    t1 = <Provider store={store}>{props.children}</Provider>;
    $[2] = props.children;
    $[3] = store;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
export { reduxStore };
export default Store;